import { createStyles, Theme } from "@material-ui/core";

export const styles = (theme: Theme) =>
  createStyles({
    menu: {
      "& .MuiMenu-paper": {
        width: 370,
        maxHeight: 504,
        boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.1)",
      },
      "& .MuiList-padding": {
        padding: 0,
      },
      "& .MuiMenuItem-root": {
        padding: "7px 0",
        width: "90%",
        alignSelf: "center",
        borderTop: "1px solid rgba(0, 0, 0, 0.12)",
      },
      "& .MuiPaper-rounded": {
        borderRadius: 20,
      },
      "& li:first-child": {
        borderTop: "none",
        "& h4": {
          fontSize: 20,
          fontWeight: "normal",
          color: "#3b465c",
          margin: "5px 0",
        },
      },
      "& li:first-child:hover": {
        cursor: "auto",
        backgroundColor: "white",
      },
      "& li:last-child": {
        borderTop: "none",
        padding: 0,
        width: "100%",
      },
      "& .MuiMenu-list": {
        display: "flex",
        flexDirection: "column",
      },
      "& .MuiDivider-root": {
        width: "90%",
        alignSelf: "center",
      },
    },
    btnVerTodas: {
      height: 60,
      borderRadius: "0 0 20px 20px",
    },
    sinNotificacion: {
      alignItems: "center",
      width: 300,
      marginLeft: 20,
      "& p": {
        lineHeight: 1.36,
        textAlign: "center",
        justifyContent: "center",
        marginTop: 20,
        marginBottom: 20,
      },
    },
    btnShadowNone: {
      backgroundColor: "transparent",
      "&:hover": {
        backgroundColor: "transparent",
      },
      "& svg": {
        fontSize: 40,
        borderRadius: 15,
      },
    },
    badge: {
      "& .MuiBadge-anchorOriginTopRightRectangle": {
        top: 10,
        right: 10,
      },
    },
  });
